import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import "./index.css";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://4c87303446efa02c67f349a6e02b2d57@o4508841485795328.ingest.us.sentry.io/4509300115701760",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 0.1, //  Capture 100% of the transactions
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 0.1, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  sendDefaultPii: true,
  ignoreErrors: [
    "React Router Future Flag Warning",
    "Evento enviado",
    /^Failed to fetch/i,
    /^Load failed/i,
    /^NetworkError when attempting to fetch resource/i,
    /^AbortError/i,
  ],
});

ReactDOM.createRoot(document.getElementById("root")).render(<App />);
